import { defineFcm } from '../shared/factory';

export const FCM_STARTER_DASHBOARD_DECISION_MAKERS_LIST_ENABLED = defineFcm(
	'starter_dashboard_decision_makers_list_enabled',
)
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig({
		owner: 'squad-capybara',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard page',
		description: 'Feature release flag that enables the decision maker list on the starter dashboard',
		mergeLogic:
			'Checks `locale` and `countryCode` to determine value. Both must be `true` for the feature to be enabled',
		import: false,
		deprecated: 'No references found. Safe to delete after 2026-09-01.',
	});
